import { generalConstants } from "@/utils/constants";
export const formatPrice = (value, addCurrency = true) => {
  let price = value;

  // Convert to int if only 0's after the decimal point else keep as float
  if (parseInt(value.split(".")[1]) === 0) price = parseInt(value);
  else price = parseFloat(value);

  if (addCurrency) {
    price = price.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: parseInt(price) === price ? 0 : 2,
      minimumFractionDigits: 0,
    });
  }

  return price;
};

export const getVariantPrice = (
  selectedVariant,
  productType = "regular",
  formatPrices = true
) => {
  let price = null;
  let salePrice = null;

  if (productType === ("sample" || "gwp")) {
    if (formatPrices) price = "Free";
    else price = 0;
  } else {
    if (selectedVariant?.priceV2) {
      if (selectedVariant?.compareAtPriceV2) {
        // If compareAtPrice > price then do not consider as sale
        if (
          parseFloat(selectedVariant?.compareAtPriceV2.amount) >
          parseFloat(selectedVariant?.priceV2?.amount)
        ) {
          salePrice = formatPrice(
            selectedVariant.priceV2.amount,
            formatPrices ? true : false
          );
          price = formatPrice(
            selectedVariant.compareAtPriceV2.amount,
            formatPrices ? true : false
          );
        }
      }
      if (!salePrice)
        price = formatPrice(
          selectedVariant.priceV2.amount,
          formatPrices ? true : false
        );
    }
  }

  return { returnedPrice: price, returnedSalePrice: salePrice };
};

export const isGiftCardType = ( selectedVariant ) => {
  let optionName = selectedVariant?.selectedOptions[0]?.name;

  return optionName == generalConstants.gift_card_option_name ? true : false;
};

export const isDonationProduct = ( selectedVariant ) => {
  let tags = [];
  if(selectedVariant?.tags)
    tags = selectedVariant.tags;
  if(selectedVariant?.product?.tags)
    tags = selectedVariant.product.tags;
  return tags && Array.isArray(tags) && tags.includes(generalConstants.product_type_donation_tag) ? true : false;
};
